'use client'

import CookieConsent from 'react-cookie-consent'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { trackCookiesConsentimento } from '@/lib/analytics'

export function CookieConsentBanner() {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Evita flash durante hidratação
  if (!mounted) return null

  const isDark = resolvedTheme === 'dark'

  return (
    <CookieConsent
      location="bottom"
      buttonText="Aceitar"
      declineButtonText="Recusar"
      ariaAcceptLabel="Aceitar"
      ariaDeclineLabel="Recusar"
      cookieName="calculamei_cookie_consent"
      // Barra fina, discreta e na marca — não domina o rodapé nem tampa a conversão.
      style={{
        background: isDark ? '#111827' : '#ffffff',
        color: isDark ? '#e5e7eb' : '#374151',
        borderTop: isDark ? '1px solid #1f2937' : '1px solid #e5e7eb',
        boxShadow: '0 -4px 16px rgba(0,0,0,0.06)',
        padding: '8px 16px',
        alignItems: 'center',
        fontSize: '12.5px',
        lineHeight: 1.4,
      }}
      contentStyle={{ flex: '1 1 260px', margin: '4px 8px' }}
      buttonWrapperClasses="cookie-btns"
      buttonStyle={{
        background: '#0F766E',
        color: '#fff',
        borderRadius: '8px',
        padding: '7px 18px',
        fontWeight: 700,
        fontSize: '12.5px',
        margin: '4px 6px',
      }}
      declineButtonStyle={{
        background: 'transparent',
        color: isDark ? '#9ca3af' : '#6b7280',
        border: isDark ? '1px solid #374151' : '1px solid #d1d5db',
        borderRadius: '8px',
        padding: '7px 14px',
        fontWeight: 600,
        fontSize: '12.5px',
        margin: '4px 6px',
      }}
      expires={365}
      enableDeclineButton={true}
      onAccept={() => trackCookiesConsentimento(true)}
      onDecline={() => trackCookiesConsentimento(false)}
    >
      🍪 Usamos cookies para melhorar sua experiência.{' '}
      <a href="/cookies" style={{ color: '#0F766E', fontWeight: 600 }}>
        Saiba mais
      </a>
      .
    </CookieConsent>
  )
}
